import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

interface Theme {
  [key: string]: string;
}
interface ThemesResponse {
  colors: { [themeName: string]: Theme; };
}

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  isDarkTheme = false;
  private themeClass = 'dark';
  private themeChangedSubject = new Subject<void>();
  public themeChanged$ = this.themeChangedSubject.asObservable();
  private themeParamMap: { [key: string]: string; } = {
    'wf': 'WARFIGHTERS',
    'warfighters': 'WARFIGHTERS',
    'pavcon': 'PavCon',
    'safire': 'SAFiRE',
    'rubi': 'RUBi',
    'dimnd': 'DiMND',
    'emirld': 'EMiRLD'
  };


  constructor(private http: HttpClient) {
    this.loadInitialTheme();
  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    document.body.classList.toggle('dark', this.isDarkTheme);
    localStorage.setItem('theme', JSON.stringify(this.isDarkTheme));
  }

  loadInitialTheme() {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      this.isDarkTheme = JSON.parse(storedTheme);
      document.body.classList.toggle('dark', this.isDarkTheme);
    }
  }
  getThemeNameFromParam(themeParam: string | null): string {

    if (!themeParam) {
      const currentTheme = this.getCurrentThemeName() || environment.defaultTheme;

      return currentTheme;
    }

    const themeName = this.themeParamMap[themeParam.toLowerCase()];

    return themeName || environment.defaultTheme;
  }

  applyThemeByName(themeName: string) {
    this.getThemes().subscribe((themesResponse) => {
      const themes = themesResponse.colors;

      const theme = themes[themeName];
      if (theme) {
        this.applyTheme(themeName, theme);
      } else {
        const defaultTheme = themes[environment.defaultTheme];
        if (defaultTheme) {
          this.applyTheme(environment.defaultTheme, defaultTheme);
        }
      }
    });
  }

  private applyTheme(themeName: string, theme: Theme): void {
    Object.entries(theme).forEach(([property, value]) => {
      document.documentElement.style.setProperty(`--${property}`, value);
    });
    localStorage.setItem(`${environment.projectName}.theme`, themeName);
  }

  getThemes(): Observable<ThemesResponse> {
    return this.http.get<ThemesResponse>('/assets/template/colors.json');
  }

  getCurrentThemeName(): string {
    return (
      localStorage.getItem(`${environment.projectName}.theme`) ||
      environment.defaultTheme
    );
  }
}
